import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

// Allineato a backend `order_status_v2` (Blocco 5 Parte B, V25 — #95).
// 7 stati: ricevuto / preventivo_omologa_generati / inviato_cliente / confermato
// / in_consultazione / in_progress / annullato.
// `label` è la CHIAVE i18n (tradotta al render); per status sconosciuti la
// chiave assente fa sì che t() ritorni la stringa stessa (status raw, come prima).
const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  ricevuto: {
    label: 'common.stati_ordine.ricevuto',
    className: 'bg-accent-info-bg text-accent-info border-[#BAE6FD]',
  },
  preventivo_omologa_generati: {
    label: 'common.stati_ordine.preventivo_omologa_generati',
    className: 'bg-accent-warning-bg text-accent-warning border-[#FDE68A]',
  },
  inviato_cliente: {
    label: 'common.stati_ordine.inviato_cliente',
    className: 'bg-[#FFFBEB] text-[#B45309] border-[#FCD34D]',
  },
  confermato: {
    label: 'common.stati_ordine.confermato',
    className: 'bg-accent-success-bg text-accent-success border-[#A7F3D0]',
  },
  in_consultazione: {
    label: 'common.stati_ordine.in_consultazione',
    className: 'bg-[#F5F3FF] text-[#7C3AED] border-[#DDD6FE]',
  },
  in_progress: {
    label: 'common.stati_ordine.in_progress',
    className: 'bg-[#EFF6FF] text-[#1D4ED8] border-[#BFDBFE]',
  },
  concluso: {
    label: 'common.stati_ordine.concluso',
    className: 'bg-stone-200 text-ink-dark border-stone-border',
  },
  annullato: {
    label: 'common.stati_ordine.annullato',
    className: 'bg-accent-danger-bg text-accent-danger border-[#FECACA]',
  },
};

interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function StatusBadge({ status, size = 'md', className }: StatusBadgeProps) {
  const { t } = useTranslation();
  const config = STATUS_CONFIG[status] ?? {
    label: status,
    className: 'bg-stone-mid text-ink-mid border-stone-border',
  };

  const sizeClass = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm font-semibold',
    lg: 'px-4 py-2 text-base font-semibold',
  }[size];

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-lg border',
        sizeClass,
        config.className,
        className,
      )}
    >
      {t(config.label)}
    </span>
  );
}
